import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { PermissionSetContainerComponent } from './permission-set-container.component';
// import { PermissionWizardListingComponent } from './perm-set-listing/perm-set-listing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';
import { PermissionWizardListingComponent } from './permission-wizard-listing/permission-wizard-listing.component';
import { PermissionWizardContainerComponent } from './permission-wizard-container.component';
import { PermissionTemplateEditComponent } from './permission-wizard-listing/permission-wizard-edit/permission-wizard-edit.component';
import { MainDetailsComponent } from './permission-wizard-listing/permission-wizard-edit/main-details/main-details.component';
import { PermissionDefsComponent } from './permission-wizard-listing/permission-wizard-edit/permission-defs/permission-defs.component';
import { TargetsComponent } from './permission-wizard-listing/permission-wizard-edit/targets/targets.component';

// import { PermSetEditTargetsComponent } from './perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines-edit/perm-set-add-lines-edit-targets/perm-set-edit-targets.component';
// import { PermSetAddLinesEditComponent } from './perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines-edit/perm-set-add-lines-edit.component';
// import { PermSetAddLinesComponent } from './perm-set-listing/perm-set-add/perm-set-add-lines/perm-set-add-lines.component';
// import { PermSetAddComponent } from './perm-set-listing/perm-set-add/perm-set-add.component';
// import { PermSetEditLinesEditTargetsComponent } from './perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines-edit/perm-set-edit-lines-edit-targets/perm-set-edit-lines-edit-targets.component';
// import { PermSetEditLinesEditComponent } from './perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines-edit/perm-set-edit-lines-edit.component';
// import { PermSetEditLinesComponent } from './perm-set-listing/perm-set-edit/perm-set-edit-lines/perm-set-edit-lines.component';
// import { PermSetEditComponent } from './perm-set-listing/perm-set-edit/perm-set-edit.component';

@NgModule({
  declarations: [
    PermissionWizardContainerComponent,
    PermissionWizardListingComponent,
    // PermissionWizardAddComponent,
    // PermSetAddLinesComponent,
    PermissionTemplateEditComponent,
    MainDetailsComponent,
    PermissionDefsComponent,
    TargetsComponent,
    // PermSetEditLinesComponent,
    // PermSetAddLinesEditComponent,
    // PermSetEditTargetsComponent,
    // PermSetEditLinesEditComponent,
    // PermSetEditLinesEditTargetsComponent
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
  ]
})
export class PermissionWizardModule { }
